import type { SavedOption } from '@/domain/WorkspaceForex/savedProducts/option/SavedOption.ts';
import type { FxOption } from '@/store/option/state.ts';
import { emptyOption } from '@/store/option/utils.ts';

export const mapToOption = ({ tileId, properties, type, clientId }: SavedOption): FxOption => {
  return emptyOption(
    tileId,
    type,
    {
      currencyPair: properties.currencyPair,
      legs: properties.legs.map((leg) => ({
        ...leg,
        type: leg.type === 'None' ? undefined : leg.type,
        legProductName: leg.legProductName ?? 'Vanilla',
      })),
      premiumPaymentDateTenor: properties.premiumPaymentDateTenor,
      settlementType: properties.settlementType,
      cutOffMarketPlace: properties.cutOffMarketPlace,
      premiumType: properties.premiumType,
      hedgeType: properties.hedgeType,
      hedges: properties.hedges,
      uiState: properties.uiState,
    },
    clientId,
  );
};
